export default __webpack_public_path__ + "static/media/编组 19.26eb8bc1.png";